export default __webpack_public_path__ + "static/media/frame_white.64d86eda.png";